import { AppState } from './types';

export default {
  getApplicationId(state: AppState): string {
    return state.applicationId;
  }
};
